import type React from 'react';

import { CmsHtml } from '#src/app/shared/components/cms';

import { usePageBody } from './hooks/usePageBody';

export const PageBody: React.FC<EmptyProps> = () => {
	const {
		data: { html, styles },
	} = usePageBody();
	return (
		<div className="[&_.bg-default]:dark:bg-background-raised! [&_.h5]:dark:text-typography-weak! [&_h5]:dark:text-typography-weak!">
			<CmsHtml html={html} styles={styles} />
		</div>
	);
};
